export const getIntegration = (state, integrationId) => {
  const integrations = state.integrations;

  return integrations.get('integrations')
    .find(item => item.get('id') === integrationId);
};

export const getIntegrationLogs = (state, integrationId) => {
  const integrations = state.integrations;
  
  return integrations.getIn(['integrationsLogsPage', integrationId, 'logs'], []);
}; 